import { createSelector } from 'reselect';

export const selectedManagerLegalProceedings = (state: any) => {
  return state.get('TransactionManagerTimeLine');
};
const makeSelectTransactions = () =>
  createSelector(selectedManagerLegalProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('transactions')) {
      return legalProceeding.get('transactions').toJS();
    }
    return null;
  });
const makeSelectContactTransaction = () =>
  createSelector(selectedManagerLegalProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('contactTransaction')) {
      return legalProceeding.get('contactTransaction').toJS();
    }
    return null;
  });

const makeSelectMissionsTransaction = () =>
  createSelector(selectedManagerLegalProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('missionsTransaction')) {
      return legalProceeding.get('missionsTransaction').toJS();
    }
    return [];
  });

const makeSelectMissionsExpertiseTransaction = () =>
  createSelector(selectedManagerLegalProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('missionExpertises')) {
      return legalProceeding.get('missionExpertises').toJS();
    }
    return [];
  });

const makeSelectJudiciaryExpertReport = () =>
  createSelector(selectedManagerLegalProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('judiciaryExpertReport')) {
      return legalProceeding.get('judiciaryExpertReport').toJS();
    }
    return [];
  });

const makeSelectTransactionInboxeAreaId = () =>
  createSelector(selectedManagerLegalProceedings, legalProceeding => {
    if (legalProceeding && legalProceeding.get('transactionInboxeAreaId')) {
      return legalProceeding.get('transactionInboxeAreaId').toJS();
    }
    return {};
  });

export {
  makeSelectTransactions,
  makeSelectContactTransaction,
  makeSelectMissionsTransaction,
  makeSelectMissionsExpertiseTransaction,
  makeSelectJudiciaryExpertReport,
  makeSelectTransactionInboxeAreaId,
};
